import { render, staticRenderFns } from "./deleteRTFComm.vue?vue&type=template&id=313f4ee6&lang=pug&"
import script from "./deleteRTFComm.vue?vue&type=script&lang=js&"
export * from "./deleteRTFComm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports